import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-cab-label",
  templateUrl: "./cab-label.component.html",
  styleUrls: ["./cab-label.component.scss"],
  standalone: true,
  imports: [TranslateModule, TooltipModule],
})
export class CabLabelComponent {
  @Input() width: string;
  @Input() label = "";
  @Input() for = "";
  @Input() customClass = "";
  @Input() customStyle = "";
  @Input() required = false;
}
